/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatusLabel = {
    Due: 'Due',
    Late: 'Late',
    NotCompliant: 'NotCompliant'
} as const;
export type StatusLabel = typeof StatusLabel[keyof typeof StatusLabel];


export function StatusLabelFromJSON(json: any): StatusLabel {
    return StatusLabelFromJSONTyped(json, false);
}

export function StatusLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusLabel {
    return json as StatusLabel;
}

export function StatusLabelToJSON(value?: StatusLabel | null): any {
    return value as any;
}

